<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :title="this.audit.farmerFullName + ' - ' + $t('Audit')"/>
        <div class="show-actions-container text-right">
          <button v-if="showRenewBtn" @click="clickOnRenewBtn" class="btn-primary ph-btn show-action-btn ml-2"
                  :disabled="!canRenewOrArchive" :title="canRenewOrArchive ? '' : $t('Only.technician.renew')">
            {{ $t('Renew') }} <i class="ph-custom ml-1 ph-folder-notch-fill"/>
          </button>
          <button v-if="showArchiveBtn" @click="clickOnArchiveBtn" class="btn-secondary ph-btn show-action-btn ml-2"
                  :disabled="!canRenewOrArchive" :title="canRenewOrArchive ? '' : $t('Only.technician.archive')">
            {{ $t('Archive') }} <i class="ph-custom ml-1 ph-folder-notch-fill"/>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <h1 class="page-title link ml-1">{{ $t('Audit.Practices') }}</h1>
            <div class="mt-1 mb-4 overflow-auto table-container b122-table-container">

              <b-table
                ref="b122Table"
                responsive
                :items="audit.practices"
                :fields="tableFields"
                stacked="lg"
                show-empty
                striped
                borderless
                sort-icon-left>

                <template #empty="scope">
                  <div class="no-result">
                    <div class="text-center mt-5 mb-2">
                      <img class="no-result-img" :src="require(`@/assets/images/b122/logo.png`)" alt="no result">
                    </div>
                    <div class="no-result-text">
                      <div class="no-result-title mb-2">{{ $t('audit.file.emptyTitle').toString() }}</div>
                    </div>
                  </div>
                </template>

                <template #cell(show)="row">
                  <button class="ph-btn action-btn flex-row justify-content-center align-items-center"
                          @click="clickOnDownloadBtn(row.item.fileUrl)">
                    <i class="ph-custom ph-download-fill"/>
                  </button>
                </template>

                <template #cell(showStepComments)="row">
                  <div class="d-flex justify-content-end">
                    <button class="ph-btn btn-primary btn-steps-comments flex-row justify-content-end align-items-center"
                            @click="showPracticeStepsComments(row)">
                      {{ $t('Audit.practice.steps.comments')}} <i class="ph-custom ph-eye-fill ml-1"/>
                    </button>
                  </div>
                </template>

                <template #cell(title)="row">
                  {{ row.item.number }} - {{ row.item.title }}
                </template>

              </b-table>
            </div>

          </b-card>

        </div>
      </div>

    </b-container>

    <show-practice-steps-modal ref="showPracticeStepsModal"></show-practice-steps-modal>
  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import {bus} from '../../main'
import ShowPracticeStepsModal from './ShowPracticeStepsModal'

export default {

  name: 'AuditCreateEdit',

  components: {
    BackArrow,
    ShowPracticeStepsModal
  },

  data () {
    return {
      auditId: this.$route.params.auditId,
      askConfirm: false,
      audit: {
        practices: []
      },
      showRenewBtn: false,
      showArchiveBtn: false,
      canRenewOrArchive: this.$store.getters.isTechnician
    }
  },
  computed: {
    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Practice.title'),
          key: 'title',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Audit.technicianNote2'),
          key: 'technicianNote',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: '',
          key: 'showStepComments',
          tdClass: 'max-width-cell'
        }
      ]
    }

  },

  mounted () {
    this.fetchData()
  },

  created () {
    bus.$on('handleSubmit', this.submitCreateEdit)
  },
  beforeDestroy () {
    bus.$off('handleSubmit', this.submitCreateEdit)
  },
  methods: {
    async fetchData () {
      await this.fetchFarmerAndAudit()
    },

    async fetchFarmerAndAudit () {
      api
        .get('/audit/' + this.auditId)
        .then(response => {
          this.audit = response.data
          if (this.audit.status === 'IN_PROGRESS') {
            this.$router.push({
              name: 'FarmerShow',
              params: {
                farmerId: this.audit.farmerId
              }
            },
            () => {
              this.$nextTick(() => {
                this.errorToast(this.$i18n.t('audit.in.progress.error'))
              })
            })
          }
          this.showRenewBtn = this.canIShowRenewBtn()
          this.showArchiveBtn = this.canIShowArchiveBtn()
        })
    },

    canIShowRenewBtn () {
      if (this.audit.status === 'COMPLETE') {
        return true
      } else {
        return !this.audit.farmerHasAudit
      }
    },

    canIShowArchiveBtn () {
      if (this.audit.status === 'ARCHIVED') {
        return false
      } else {
        return true
      }
    },

    async clickOnDownloadBtn (fileUrl) {
      const res = await api.get(fileUrl, {
        responseType: 'blob'
      })

      var disposition = res.headers['content-disposition'] || ''
      var filename = 'download'

      if (disposition) {
        var match = disposition.match(/filename="?([^"]+)"?/i)
        if (match && match[1]) {
          filename = match[1]
        }
      }

      var blobUrl = window.URL.createObjectURL(res.data)
      var a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    },

    clickOnArchiveBtn () {
      let data = new FormData()
      data.append('auditId', this.audit.id)
      api({
        method: 'POST',
        url: '/audit/archiveAudit',
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'FarmerShow',
            params: {
              farmerId: this.audit.farmerId
            }
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.$i18n.t('Audit') + ' ' + this.$i18n.t('archived'))
            })
          })
        })
        .catch((error) => {
          var errorMessage = 'Error'
          if (error.response.status === 403) {
            errorMessage = error.response.data.message
          }
          this.$bvToast.toast(this.$i18n.t(errorMessage), {
            title: this.$i18n.t('Error.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          })
        })
    },

    clickOnRenewBtn () {
      let data = new FormData()
      data.append('auditId', this.audit.id)
      api({
        method: 'POST',
        url: '/audit/renewAudit',
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'AuditCreate',
            params: {
              farmerId: this.audit.farmerId
            }
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.$i18n.t('Audit') + ' ' + this.$i18n.t('renewed'))
            })
          })
        })
        .catch((error) => {
          var errorMessage = 'Error'
          if (error.response.status === 403) {
            errorMessage = error.response.data.message
          }
          this.$bvToast.toast(this.$i18n.t(errorMessage), {
            title: this.$i18n.t('Error.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          })
        })
    },

    showPracticeStepsComments (row) {
      this.$refs.showPracticeStepsModal.practiceSteps = row.item.practiceSteps
      console.log(this.$refs.showPracticeStepsModal.practiceSteps)
      this.$bvModal.show('show-practice-steps-modal')
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },

    errorToast (message) {
      this.$bvToast.toast(message, {
        title: this.$i18n.t('Error.title'),
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        solid: true
      })
    }
  }

}
</script>

<style scoped>
/*** Table ***/

.b122-table-container >>> .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(153, 204, 85, 0.2);
}

.b122-table-container >>> th[role="columnheader"] {
  vertical-align: middle;
  color: var(--main-grey);
  font-family: "Museo700", "Arial", sans-serif;
  font-weight: 200;

}

.b122-table-container >>> td[role="cell"] {
  vertical-align: middle;
  color: var(--main-black);
  font-family: "Roboto", "Arial", sans-serif;
}

.b122-table-container >>> .table-striped tbody .b-table-empty-row {
  background-color: white !important;
}

.b122-table-container .no-result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: grey;
}

.b122-table-container .no-result-text {
  text-align: center;
  max-width: 400px;
}

.b122-table-container .no-result-title {
  color: var(--main-black);
  font-family: "Museo700", "Arial", sans-serif;
}

.b122-table-container .busy {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--main-green-light);
  height: 100px;
  font-size: 1.2em;
}

.b122-table-container >>> td a {
  color: var(--main-grey);
}
</style>

<style>

/*** Actions ***/
.actions-container {
  min-width: 80px;
}

.action-btn {
  background-color: var(--main-green-light);
  border: none;
  height: 32px;
  width: 32px;
  color: var(--main-color-dark);
  border-radius: var(--main-border-radius);
  padding: 6px;
}

.action-btn:hover {
  background-color: var(--main-color-medium);
}

.edit {
  background-color: var(--main-green-light);
  color: var(--main-color-dark);
}

.edit:hover {
  background-color: var(--main-color-medium);
}

.delete {
  background-color: var(--main-red-light);
  color: var(--main-red-dark);
}

.delete:hover {
  background-color: var(--main-red-medium);
}

.table-container {
  overflow-x: scroll;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.table-container::-webkit-scrollbar {
  width: 5px;
}

.table-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ffffff;
}

.float-right {
  float: right;
}

.empty-row {
  height: 56px;
}

.add-practice-btn {
  margin-top: -36px;
}

.no-result-img {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/audit/AuditShow.vue